import React from 'react';
import { Button, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { useForm, requiredField, requiredEmailField } from '../../utils/validators';
import PropTypes from 'prop-types';

export default function PartnerIdentity({ formState, onSubmit, onCancel }) {
    const { t } = useTranslation();

    const validators = React.useMemo(() => {
        return {
            from_address_name: requiredField,
            reply_to_name: requiredField,
            from_address_email: requiredEmailField,
            reply_to_email: requiredEmailField
        };
    }, []);

    const [formIdentity, setFormIdentity, setFormIdentityObject, identityErrors, identityValidate] = useForm(
        {
            from_address_name: formState.from_address.name,
            from_address_email: formState.from_address.email,
            reply_to_name: formState.reply_to.name,
            reply_to_email: formState.reply_to.email
        },
        validators
    );

    return (
        <div>
            <Form.Field error={identityErrors['from_address_name'] ? true : false}>
                <Form.Label label={t('ticket.partners.settings.identity.name')} />
                <Form.Input
                    value={formIdentity.from_address_name}
                    required={true}
                    onChange={event => setFormIdentityObject({ ...formIdentity, from_address_name: event.target.value, reply_to_name: event.target.value })}
                />
                <Form.FieldErrors errors={identityErrors['from_address_name'] ? [t(identityErrors['from_address_name'])] : ['']} />
            </Form.Field>
            <Form.Field error={identityErrors['reply_to_email'] ? true : false}>
                <Form.Label label={t('ticket.partners.settings.identity.email')} />
                <Form.Input value={formIdentity.reply_to_email} required={true} onChange={event => setFormIdentity('reply_to_email', event.target.value)} />
                <Form.FieldErrors errors={identityErrors['reply_to_email'] ? [t(identityErrors['reply_to_email'])] : ['']} />
            </Form.Field>
            <Button
                primary
                style={{ marginTop: '10px', marginRight: '10px' }}
                label={formState.id ? t('ticket.common.action.edit') : t('ticket.common.action.save')}
                onClick={() => {
                    if (!identityValidate()) {
                        return;
                    }
                    onSubmit(formIdentity);
                }}
            />
            <Button style={{ marginTop: '10px' }} label={t('ticket.common.action.cancel')} onClick={onCancel} />
        </div>
    );
}

PartnerIdentity.propTypes = {
    formState: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};
